import { MenuListItem, MenuListItemProps } from '@ui/order/menu-list-item';
import { LazyImage } from '@ui/common/lazy-image.tsx';
import { OrderStatus } from '@ui/order/order-status';
import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  useDisclosure,
} from '@heroui/react';
import { InfoCircle } from 'iconsax-react';
import { IOrder } from '@shared/types.ts';
import { OrderUti } from '@shared/const/order.ts';
import { F } from '@shared/utils/format.ts';

export type OrderDetailsProps = {
  onPress?: () => void;
  isLoading?: boolean;
  isSubmitting?: boolean;
  order: IOrder;
};

export const OrderDetails = ({
  order,
  isLoading,
  isSubmitting,
  onPress,
}: OrderDetailsProps) => {
  const cancelModal = useDisclosure();

  const items: MenuListItemProps[] = [
    { title: 'Номер заказа:', description: `№${order.id}`, weight: 'semibold' },
    { title: 'Дата оформления:', description: '11.06.2025' },
    { title: 'Кол-во товаров:', description: `${order.items.length} шт` },
    {
      title: 'Способ оплаты:',
      description: (
        <div className="h-5 max-w-32">
          <LazyImage src="/woopay_pay.png" />
        </div>
      ),
    },
    {
      title: 'Общая сумма:',
      description: `${F.number(order.total_price)} ₸ `,
      weight: 'semibold',
    },
  ];

  const isShowCancel = ['idle', 'delivery'].includes(
    OrderUti.status(order.status)
  );

  return (
    <>
      <div className="flex flex-col gap-y-3 lg:gap-y-4 py-6">
        <OrderStatus
          className="lg:text-xl"
          isLoading={isLoading}
          variant={OrderUti.status(order.status)}
        />
        {items.map((item, index) => (
          <MenuListItem key={index} {...item} isLoading={isLoading} />
        ))}
      </div>

      {isShowCancel && (
        <Button
          fullWidth
          isLoading={isSubmitting}
          variant="bordered"
          size="lg"
          className="mb-4"
          onPress={cancelModal.onOpen}
        >
          Отменить заказ
        </Button>
      )}

      <Modal
        placement="center"
        size="2xl"
        hideCloseButton
        isOpen={cancelModal.isOpen}
        onOpenChange={cancelModal.onOpenChange}
      >
        <ModalContent>
          {(onClose) => (
            <>
              <ModalHeader className="flex flex-row items-center gap-x-3">
                <InfoCircle size="24" color="#F53639" className="rotate-180" />

                <p className="text-[#222222] text-lg font-semibold">
                  Отменить заказ?
                </p>
              </ModalHeader>
              <ModalBody>
                <p className="text-[#60656C] text-sm">
                  Вы действительно хотите отменить заказ
                </p>
              </ModalBody>
              <ModalFooter>
                <Button
                  fullWidth
                  size="lg"
                  color="primary"
                  className="text-medium"
                  variant="solid"
                  onPress={onClose}
                >
                  Не отменять
                </Button>
                <Button
                  size="lg"
                  fullWidth
                  isLoading={isLoading}
                  variant="bordered"
                  className="text-medium"
                  onPress={() => {
                    onPress?.();
                    onClose();
                  }}
                >
                  Отменить
                </Button>
              </ModalFooter>
            </>
          )}
        </ModalContent>
      </Modal>
    </>
  );
};

export const OrderDeliveryDetails = ({ order }: { order: IOrder }) => {
  const items: MenuListItemProps[] = [
    {
      title: 'Адрес:',
      description: order.delivery_address || '',
      variant: 'col',
    },
    {
      title: 'Комментарий для курьера:',
      description: order.comment || '',
      variant: 'col',
    },
  ];

  return (
    <div className="flex flex-col gap-y-3 py-4">
      {items.map((item, index) => (
        <MenuListItem key={index} {...item} />
      ))}
    </div>
  );
};
